import { ColorModeBgPropKeys } from 'src/app/styles/colors';
import styled, { css } from 'styled-components';
import { spacingStyles, StyledSpacingProps } from '../Spacing.styles';
import { cssVar } from 'src/app/styles/helper';
import { WidthPropKeys } from 'src/app/styles/spacing';

interface SectionLayoutContainerProps {
  $background?: ColorModeBgPropKeys;
}

export type ZIndexType = 'unset' | number;

export const SectionLayoutContainer = styled.div<SectionLayoutContainerProps>`
  width: 100%;
  position: relative;

  ${({ $background }) =>
    !$background
      ? ''
      : css`
          background: ${cssVar($background)};
        `}
`;

export const BackgroundImageContainer = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

interface SectionLayoutContentProps extends StyledSpacingProps {
  $maxWidth?: WidthPropKeys;
  $zIndex?: ZIndexType;
}

export const SectionLayoutContent = styled.div<SectionLayoutContentProps>`
  width: 100%;
  position: relative;
  z-index: ${({ $zIndex }) => $zIndex || 2};

  ${({ $maxWidth }) =>
    !$maxWidth
      ? ''
      : css`
          max-width: ${cssVar($maxWidth)};
        `}

  margin: 0 auto;

  ${spacingStyles}
`;
